// removed by extract-text-webpack-plugin
module.exports = {"component":"_27ZccLSn59QOe2DFK9_ERJ"};